import { CandleValidationApi, CandleWorkerApi, PairApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';
import { normalizeCandleValidations } from '../candle-validations/normalizers';
import { CandleValidation } from '../candle-validations/types';
import { normalizeCandleWorkers } from '../candle-workers/normalizers';
import { CandleWorker } from '../candle-workers/types';

import { normalizePair, normalizePairs } from './normalizers';
import { Pair } from './types';

export class VoladeumPairs extends Axios {
  async list(): Promise<VoladeumResponse<Pair[]>> {
    const res = await this.get<VoladeumResponse<PairApi[]>>('/v1/pairs');
    return {
      success: res.success,
      error: res.error,
      data: normalizePairs(res.data),
    };
  }

  async fetch(pair_id?: string): Promise<VoladeumResponse<Pair>> {
    const res = await this.get<VoladeumResponse<PairApi>>(`/v1/pairs/${pair_id}`);
    return {
      success: res.success,
      error: res.error,
      data: normalizePair(res.data),
    };
  }

  async run(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(`/v1/pairs/${pair_id}/run`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async activate(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(`/v1/pairs/${pair_id}/activate`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async archive(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(`/v1/pairs/${pair_id}/archive`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async pause(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(`/v1/pairs/${pair_id}/pause`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async candleValidations(pair_id?: string): Promise<VoladeumResponse<CandleValidation[]>> {
    const res = await this.get<VoladeumResponse<CandleValidationApi[]>>(
      `/v1/pairs/${pair_id}/candle-validations`
    );
    return {
      success: res.success,
      error: res.error,
      data: normalizeCandleValidations(res.data),
    };
  }

  async candleWorkers(pair_id?: string): Promise<VoladeumResponse<CandleWorker[]>> {
    const res = await this.get<VoladeumResponse<CandleWorkerApi[]>>(
      `/v1/pairs/${pair_id}/candle-workers`
    );
    return {
      success: res.success,
      error: res.error,
      data: normalizeCandleWorkers(res.data),
    };
  }

  async runCandleWorkers(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(
      `/v1/pairs/${pair_id}/candle-workers/run`
    );
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async pauseCandleWorkers(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(
      `/v1/pairs/${pair_id}/candle-workers/pause`
    );
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async deleteCandleWorkers(pair_id?: string): Promise<VoladeumResponse<string>> {
    const res = await this.delete<VoladeumResponse<string>>(`/v1/pairs/${pair_id}/candle-workers`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
}
